import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import './FinancialPage.css'
import { getAllOrderedService, getContractorTransactions } from '../../services/servicesServices';
import DataTablePagination from '../../components/Table/DataTablePagination';
import { fileDownloaderWithName } from '../../utils/fileDownloader';
import Payment from './additionalFields/Payment';
import ReceiptTransaction from './additionalFields/ReceiptTransaction';
import { convertDateToJalaali } from '../../utils/convertDate';
import { Box, CircularProgress, Modal, Typography } from '@mui/material';
import Alert from '../../utils/Alert.js';
import { getInventory, withdrawalRequest } from '../../services/usersServices';
import { useNavigate } from 'react-router-dom';
import ModalContainer from '../../components/ModalContainer';

const FinancialPage = () => {
    const [forceRequest, setForceRequest] = useState(0);
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [open, setOpen] = useState(false);
    const [amount, setAmount] = useState("")

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const transactionCol = [
            {
                field: null,
                text: "مبلغ (تومان)",
                element: (rowData) => <Payment rowData={rowData} />,
            },
            {
                field: "description",
                text: "بابت",
            },
            {
                field: null,
                text: "رسید",
                element: (rowData) => <ReceiptTransaction rowData={rowData} />,
            },
            {
                field: null,
                text: "تاریخ",
                element: (rowData) => <span>{convertDateToJalaali(rowData.transaction_date)}</span>,
            },
        ];

    
    const handleSubmit = async (e) => {
        e.preventDefault();

        const parsedAmount = parseInt(amount, 10)

        if (!amount || isNaN(parsedAmount) || parsedAmount <= 0) {
            Alert("خطا", "عدد وارد شده معتبر نمی‌باشد.", "error");
        } else {
            const requestData = {amount: parsedAmount}
            try {
                const response = await withdrawalRequest(requestData);
                if (response.status == 200) {
                    handleClose()
                    getWalletBalance()
                    Alert("انجام عملیات", "درخواست شما با موفقیت ایجاد شد", "success");
                }
            } catch (error) {
                if (error.response.data.code === "COMPANY") {
                    Alert("خطا", "ابتدا شرکت پیش فرض خود را تعریف کنید.", "error");
                }
                else if (error.response.data.code === "COMPANY_INFORMATION") {
                    Alert("خطا", "اطلاعات شرکت ناقص است. (شماره شبا را وارد کنید)", "error");
                }
                else if (error.response.data.code[0] === "WITHDRAWING_MONEY") {
                    Alert("خطا", "امکان برداشت با مبلغ کمتر از ۱۰۰ هزار تومان وجود ندارد.", "error");
                }
                else if (error.response.data.code[0] === "INSUFFICIENT_INVENTORY") {
                    Alert("خطا", "موجودی کیف پول کافی نمی‌باشد.", "error");
                }
            }

        }
    }


    const getWalletBalance = async () => {
        setLoading(true);
        try {
            const response = await getInventory();
            if (response.status === 200) {
                setData(response.data);
                setLoading(false);
            }
        } catch (error) {
            console.error("There is a problem in receiving the inventory");
            setLoading(false);
        }
    }

    useEffect(() => {
        getWalletBalance()
    }, [])

    return (
        <>
            {
                !loading ? ( 
                    <>
                        <h1 className="ms-1 text-2xl text-center mb-4">امور مالی</h1>
                        <div className="page-container">
                            <div className="wallet-info">
                                <h3 className="ms-1 text-1xl mb-4">کیف پول</h3>
                                <h3 className="ms-1 text-2xl mb-4">
                                    {`${Number(data ? data.inventory : 0).toLocaleString()} تومان`}
                                </h3>
                            </div>
                            <div className="withdrawable-info">
                                <h3 className="ms-1 text-1xl mb-4">قابل برداشت</h3>
                                <h3 className="ms-1 text-2xl mb-4">
                                    {`${Number(data ? data.inventory : 0).toLocaleString()} تومان`}
                                </h3>
                            </div>
                        </div>
                        <div className="button-container">
                            <Button
                                variant="contained"
                                onClick={handleOpen}
                                className="submit-button"
                                size="large"
                            >
                                ثبت درخواست برداشت
                            </Button>
                        </div>
                        <div style={{ marginTop: "2rem" }}>
                            <DataTablePagination
                            tableCols={transactionCol}
                            title={"تراکنش ها"}
                            withoutSearch={true}
                            withoutLineNumber={true}
                            APIFunction={getContractorTransactions}
                            dataField={"transactions"}
                            forceRequest={forceRequest}
                            setForceRequest={setForceRequest}
                            ></DataTablePagination>
                        </div>
                        <ModalContainer
                            alwaysOpen={false}
                            onClose={handleClose}
                            isOpen={open}
                            title={"درخواست برداشت"}
                        >
                            <div className="details-container">
                              <div className="info-row">
                                <p>شماره شبا</p>
                                <p>{data.shaba ? data.shaba : "وجود ندارد"}</p>
                              </div>
                              <div className="info-row">
                                <p>نام صاحب حساب</p>
                                <p>{data.full_name && data.company_name ? `${data.full_name} - ${data.company_name}` : `${data.full_name}`}</p>
                              </div>
                            </div>

                            <form onSubmit={handleSubmit}>  
                                <div className="input-container">  
                                    <span>مبلغ</span>  
                                    <input  
                                        type="number"  
                                        className="border-2 rounded-md outline-none w-72 px-2 py-1 mb-2 me-2"  
                                        value={amount}  
                                        onChange={(e) => setAmount(e.target.value)}  
                                        required  
                                        min="1000"  
                                    />  
                                    <span>تومان</span>  
                                </div>  

                                <div className="button-container">  
                                    <Button variant='contained' type="submit" className="submit-button">  
                                        ثبت درخواست  
                                    </Button>  
                                </div>  
                            </form>  
                        </ModalContainer>
                    </>
                ) : (
                    <>
                    <div className="w-full flex flex-col 
                    items-center justify-center
                    px-3 py-10">
                        <CircularProgress size={50} />
                        <span className="text-primary mt-4 
                        text-xl opacity-animation">
                            صبر کنید...
                        </span>
                    </div>
                    </>
                )
            }

        </>
    );
};

export default FinancialPage;